// Green Connect — site-wide constants
export const BRAND = {
  name: "Green Connect",
  tagline: "Your garden. Their craft. One platform.",
  established: 2022,
  area: "Leeds & surrounding areas",
  phone: "+447367025779",
  landline: "01135197348",
  socials: {
    tiktok: "https://www.tiktok.com/@gconnectleeds",
    facebook: "https://www.facebook.com/share/1BaPsTVBts/",
  },
  logoUrl:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_garden-site-launch/artifacts/kbopl0xr_1E44494D-6042-4EB3-9577-F859E0AA8CD1.png",
  heroUrl:
    "https://customer-assets.emergentagent.com/job_71757ad0-5a35-43b6-8dea-e2347e74092b/artifacts/jxwbcarm_F7C0C62F-A130-4BBE-A663-9EF9DABD6FCD.png",
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_garden-site-launch/artifacts/vdmf7kxw_IMG_0972.jpeg",
      title: "Driveway & Front Lawn Refresh",
      caption: "Stamped concrete driveway cleaned and front lawn re-laid.",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_71757ad0-5a35-43b6-8dea-e2347e74092b/artifacts/texanvrl_IMG_0973.jpeg",
      title: "Front Garden Restoration",
      caption: "Lawn renovation alongside stamped-concrete driveway tidy-up.",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_71757ad0-5a35-43b6-8dea-e2347e74092b/artifacts/cj4kfmcq_IMG_0975.jpeg",
      title: "Fencing & Garden Tidy",
      caption: "New larch lap fence panels and full back-garden makeover.",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_garden-site-launch/artifacts/8xr1hdu5_IMG_0971.jpeg",
      title: "Crazy Paving Patio",
      caption: "Patio cleared, new fence panels, fresh borders.",
    },
  ],
};

export const SERVICES = [
  {
    slug: "regular-garden-maintenance",
    icon: "Sprout",
    category: "Garden",
    name: "Regular Garden Maintenance",
    short: "Keep your garden looking sharp all year round.",
    rows: [
      ["Front Garden Tidy-Up", "£30"],
      ["Back Garden Tidy-Up", "£40"],
      ["Full Garden Maintenance Visit", "£50"],
      ["Monthly Garden Care Package", "£65/month"],
      ["Fortnightly Garden Care Package", "£100/month"],
    ],
  },
  {
    slug: "lawn-care",
    icon: "Scissors",
    category: "Garden",
    name: "Lawn Care Services",
    short: "Mowing, edging, scarifying & feeding.",
    rows: [
      ["Lawn Mowing (Small Garden)", "£20"],
      ["Lawn Mowing (Medium Garden)", "£30"],
      ["Lawn Mowing (Large Garden)", "£40+"],
      ["Lawn Edging", "£10"],
      ["Scarifying", "£50"],
      ["Aeration", "£45"],
      ["Lawn Feeding & Treatment", "£35"],
    ],
  },
  {
    slug: "hedge-shrub",
    icon: "Trees",
    category: "Garden",
    name: "Hedge & Shrub Care",
    short: "Trimming, shaping & full reductions.",
    rows: [
      ["Hedge Trimming (Small)", "£30"],
      ["Hedge Trimming (Medium)", "£60"],
      ["Hedge Trimming (Large)", "£80"],
      ["Shrub Pruning", "£25"],
      ["Full Hedge Reduction", "Quote Required"],
    ],
  },
  {
    slug: "garden-clearances",
    icon: "Leaf",
    category: "Garden",
    name: "Garden Clearances",
    short: "From a quick tidy to full restorations.",
    rows: [
      ["General Garden Clearance", "£80"],
      ["Overgrown Garden Restoration", "£150"],
      ["Leaf Clearance", "£40"],
      ["Green Waste Removal", "£35"],
      ["End of Tenancy Garden Tidy", "£120"],
    ],
  },
  {
    slug: "planting",
    icon: "Flower2",
    category: "Garden",
    name: "Planting & Garden Improvements",
    short: "Beds, borders and seasonal colour.",
    rows: [
      ["Flower Bed Preparation", "£50"],
      ["Seasonal Planting", "£60"],
      ["Bark & Mulch Installation", "£65"],
      ["Decorative Stone Installation", "£75"],
      ["New Plant Installation", "Quote Required"],
    ],
  },
  {
    slug: "tree-services",
    icon: "TreePine",
    category: "Garden",
    name: "Tree Services",
    short: "Pruning, removal & stump grinding.",
    rows: [
      ["Small Tree Pruning", "£60"],
      ["Medium Tree Pruning", "£120"],
      ["Tree Removal", "Quote Required"],
      ["Stump Grinding", "£80"],
    ],
  },
  {
    slug: "hard-landscaping",
    icon: "Hammer",
    category: "Garden",
    name: "Hard Landscaping",
    short: "Patios, driveways, fencing & paths.",
    rows: [
      ["Patio Cleaning", "£50"],
      ["Pressure Washing Driveways", "£70"],
      ["Fence Repairs", "£50"],
      ["New Fence Panels Installed", "£90 per panel"],
      ["Patio Installation", "Quote Required"],
      ["Decorative Pathways", "Quote Required"],
    ],
  },
  {
    slug: "waste-removal",
    icon: "Trash2",
    category: "Garden",
    name: "Waste Removal",
    short: "Single items to full loads — fully licensed disposal.",
    rows: [
      ["Single Item Collection", "Quote Required"],
      ["Small Load (¼ van)", "Quote Required"],
      ["Half Van Load", "Quote Required"],
      ["Full Van Load", "Quote Required"],
      ["Builders' Waste / Rubble Removal", "Quote Required"],
      ["Bulky Item (mattress, white goods)", "Quote Required"],
      ["Garden / Green Waste Removal", "Quote Required"],
      ["House or Garage Clearance", "Quote Required"],
      ["Office / Commercial Clearance", "Quote Required"],
      ["Fly-Tip / Emergency Cleanup", "Quote Required"],
    ],
  },
  {
    slug: "joinery",
    icon: "Wrench",
    category: "Joinery",
    name: "Joinery",
    short: "Bespoke woodwork, fitted furniture, doors & built-ins.",
    rows: [
      ["Internal Door Hanging", "Quote Required"],
      ["External Door Installation", "Quote Required"],
      ["Skirting Boards & Architrave", "Quote Required"],
      ["Fitted Wardrobes / Built-in Storage", "Quote Required"],
      ["Bespoke Shelving", "Quote Required"],
      ["Staircase Repairs", "Quote Required"],
      ["Window Frame Repairs", "Quote Required"],
      ["Custom Joinery (consultation)", "Quote Required"],
    ],
  },
  {
    slug: "property-maintenance",
    icon: "Home",
    category: "Property",
    name: "Property Maintenance",
    short: "Handyman repairs, fixings & general upkeep — one call sorts it.",
    rows: [
      ["General Handyman Visit (per hour)", "Quote Required"],
      ["Flat-Pack Furniture Assembly", "Quote Required"],
      ["TV / Mirror / Shelf Mounting", "Quote Required"],
      ["Door & Lock Repairs", "Quote Required"],
      ["Minor Plastering & Patch Repairs", "Quote Required"],
      ["Silicone / Sealant Renewal", "Quote Required"],
      ["Gutter Cleaning & Repairs", "Quote Required"],
      ["Pre-Tenancy / Snag Lists", "Quote Required"],
    ],
  },
  {
    slug: "painting-decorating",
    icon: "Paintbrush",
    category: "Painting",
    name: "Painting & Decorating",
    short: "Interior & exterior, walls, woodwork & wallpapering.",
    rows: [
      ["Single Room Repaint", "Quote Required"],
      ["Whole House Repaint", "Quote Required"],
      ["Ceiling Painting", "Quote Required"],
      ["Woodwork & Trim Painting", "Quote Required"],
      ["Wallpaper Hanging", "Quote Required"],
      ["Wallpaper Removal", "Quote Required"],
      ["Exterior Walls & Render", "Quote Required"],
      ["Exterior Woodwork (fences, doors, frames)", "Quote Required"],
    ],
  },
];

export const PACKAGES = [
  { name: "Bronze", price: "£60", priceNum: 60, tagline: "The essentials",
    features: ["Lawn Mowing", "Edging", "Weed Control", "General Tidy Up"], highlight: false },
  { name: "Silver", price: "£95", priceNum: 95, tagline: "Most popular",
    features: ["Everything in Bronze", "Hedge Trimming", "Shrub Maintenance", "Green Waste Removal"], highlight: true },
  { name: "Gold", price: "£150", priceNum: 150, tagline: "The full makeover",
    features: ["Complete Garden Makeover Visit", "Lawn Care", "Hedge Trimming", "Garden Clearance", "Weed Treatment", "Waste Removal"], highlight: false },
];

export const TIME_SLOTS = [
  "08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00",
];

export const WHY_CHOOSE = [
  { title: "Vetted Pros", desc: "Every contractor approved by our team — ID & insurance checked.", icon: "ShieldCheck" },
  { title: "Free Quotes", desc: "Browse pricing, get matched, pay a small platform fee. That's it.", icon: "BadgePoundSterling" },
  { title: "Rate & Review", desc: "Real reviews from real customers. Quality stays high.", icon: "Star" },
  { title: "Local Network", desc: "Built in Leeds. Expanding nationally — pros near you.", icon: "MapPin" },
  { title: "Eco-Friendly", desc: "Sustainable practices. Green waste recycled.", icon: "Leaf" },
  { title: "Easy Booking", desc: "Pick a service, upload photos, pay fee, get a date. Done.", icon: "Sparkles" },
];
